"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputControl = exports.StyledInput = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../helpers");
const useEnterKeyStopPropagation_1 = require("../../helpers/useEnterKeyStopPropagation");
exports.StyledInput = styled_components_1.default.input `
    flex-shrink: 1;
    display: inline-flex;
    box-sizing: border-box;
    outline: none;
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    max-width: 100%;
    min-width: 2ch;

    ${({ hasSpacing, theme }) => (0, styled_components_1.css) `
        padding-right: ${hasSpacing ? theme === null || theme === void 0 ? void 0 : theme.spacing.s : 0};
        padding-left: ${hasSpacing ? theme === null || theme === void 0 ? void 0 : theme.spacing.s : 0};
        font-family: ${theme.fonts.family};
        font-size: ${theme.fonts.sizes.m};
        line-height: ${theme.fonts.lineHeights.m};
        color: ${theme.fonts.colors.primary};
    `};
    ${({ width }) => width
    ? (0, styled_components_1.css) `
                  width: ${width};
              `
    : (0, styled_components_1.css) `
                  flex: 1;
              `};
    ${({ height }) => height &&
    (0, styled_components_1.css) `
            height: ${height};
            line-height: ${height};
        `};

    &::-ms-reveal {
        display: none;
    }

    &::-ms-clear {
        display: none;
    }

    ${({ theme }) => (0, styled_components_1.css) `
        ::placeholder {
            color: ${theme.colorTextLight};
        }

        :-ms-input-placeholder {
            color: ${theme.colorTextLight};
        }

        ::-ms-input-placeholder {
            color: ${theme.colorTextLight};
        }

        &:disabled {
            color: ${theme.colorTextLight};
            /**
            Fix text color bug in Safari
           */
            -webkit-text-fill-color: ${theme.colorTextLight};
        }
    `}

    ${({ hasBorder, theme }) => hasBorder &&
    (0, styled_components_1.css) `
            border-width: ${helpers_1.BASE_BORDER_WIDTH};
            border-style: solid;
            border-color: ${theme.colorBorderMain};
        `};

    ${({ error, theme }) => error &&
    (0, styled_components_1.css) `
            color: ${theme.colorTextError};
        `}
`;
exports.InputControl = (0, helpers_1.createUIElement)('InputControl', (_a, externalRef) => {
    var { className, width, height, hasSpacing, hasBorder, error, autocomplete = 'off', hasEnterKeyStopPropagation = false, onKeyEnterPress, onFocus, onBlur, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, value, placeholder, disabled, readOnly, maxLength, onChange, type, tabIndex } = _a, rest = __rest(_a, ["className", "width", "height", "hasSpacing", "hasBorder", "error", "autocomplete", "hasEnterKeyStopPropagation", "onKeyEnterPress", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", "value", "placeholder", "disabled", "readOnly", "maxLength", "onChange", "type", "tabIndex"]);
    const { ref } = (0, useEnterKeyStopPropagation_1.useEnterKeyStopPropagation)({
        ref: externalRef,
        hasStopPropagation: hasEnterKeyStopPropagation,
        onKeyEnterPress
    });
    return (react_1.default.createElement(exports.StyledInput, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'input-control', className: `vm-InputControl ${className}`, width: width, height: height, hasSpacing: hasSpacing, hasBorder: hasBorder, error: error, autoComplete: autocomplete, onFocus: onFocus, onBlur: onBlur, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style, value: value, placeholder: placeholder, disabled: disabled, readOnly: readOnly, maxLength: maxLength, onChange: onChange, type: type, tabIndex: tabIndex })));
});
//# sourceMappingURL=InputControl.js.map